<template>
  <div>
    <a-row v-for="(item, index) in catalogs.items" :key="index" :gutter="16">
      <a-col :span="8">
        <a-form-model-item
          label="SKU"
          :prop="'catalogs.items.' + index + '.sku_exist'"
          :rules="{ validator: validateSku, trigger: 'blur' }"
        >
          <a-spin :spinning="item.loading">
            <a-input
              v-model="item.sku"
              size="large"
              :disabled="isLoading || item.loading"
              @change="event => item.sku = event.target.value.toUpperCase()"
              @blur="onCheckSku($event, index)"
            />
          </a-spin>
          <a-input v-model="item.sku_exist" style="display: none" />
        </a-form-model-item>
      </a-col>
      <a-col :span="8">
        <a-form-model-item :label="$t('product.factory_sku')" :prop="'catalogs.items.' + index + '.factory_sku'">
          <a-input
            v-model="item.factory_sku"
            size="large"
            :disabled="isLoading"
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="8">
        <a-form-model-item :label="$t('product.barcode')" :prop="'catalogs.items.' + index + '.barcode'">
          <a-input
            v-model="item.barcode"
            size="large"
            :disabled="isLoading"
            @change="event => item.barcode = event.target.value.toUpperCase()"
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="24">
        <a-form-model-item
          class="mt-3"
          :prop="'catalogs.items.' + index + '.price.value'"
          :rules="[{ required: true, message: 'Harga harus diisi', trigger: 'blur' }]"
        >
          <a-input-group size="large" class="variant-price" compact>
            <div class="addon-before">
              {{ currency }}
            </div>
            <InputNumber
              v-if="item.price.currency === 'IDR'"
              v-model="priceLabel"
              style="width: 380px"
              :disabled="isLoading"
              @blur="onBlurPrice($event, index)"
            />
            <InputNumberDecimal
              v-else
              v-model="priceLabel"
              style="width: 380px"
              :disabled="isLoading"
              @blur="onBlurPrice($event, index)"
            />
            <a-input v-model="item.price.value" style="display: none;" />
            <a-select
              v-model="item.price.uom"
              class="variant-uom"
              style="width: 125px"
              :disabled="isLoading"
              @change="onChangeUom($event, index)"
            >
              <div slot="dropdownRender" slot-scope="menu">
                <v-nodes :vnodes="menu" />
                <a-divider style="margin: 2px 0;" />
                <div class="btn-uom" @mousedown="e => e.preventDefault()" @click="$emit('addUom')">
                  {{ $t('product.add_unit') }}
                </div>
              </div>
              <a-select-option v-for="unit in uomList" :key="unit" :value="unit">
                {{ unit }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-form-model-item class="mt-1">
      <a-checkbox v-model="isProductBundling" :disabled="isLoading" @change="onChangeBundle">
        {{ $t('product.product_bundling') }}
      </a-checkbox>
    </a-form-model-item>
    <div v-if="isProductBundling">
      <a-form-model-item prop="catalogs.bundling.bundling_type">
        <a-radio-group v-model="catalogs.bundling.bundling_type" :disabled="isLoading">
          <a-radio value="SOFT">
            {{ $t('product.soft_bundling') }}
          </a-radio>
          <!-- <a-radio value="HARD">
            Hard Bundling
          </a-radio> -->
        </a-radio-group>
      </a-form-model-item>

      <table class="table-bundling">
        <thead>
          <tr>
            <th>{{ $t('product.product_name_bundling') }}</th>
            <th>{{ $t('product.quantity_bundling') }}</th>
            <th>#</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!catalogs.bundling.bundles.length">
            <td colspan="3">
              {{ $t('product.no_data') }}
            </td>
          </tr>
          <tr v-for="(catalog, index) in catalogs.bundling.bundles" :key="index">
            <td>
              <div>{{ catalog.title }}</div>
              <div style="font-size: 90%; font-weight: 600">
                SKU: {{ catalog.sku }}
              </div>
              <div v-if="catalog.message" style="font-size: 85%; color: red">
                {{ catalog.message }}
              </div>
            </td>
            <td>
              <a-input-group compact>
                <a-input-number
                  v-model="catalog.quantity"
                  :min="1"
                  size="large"
                  :disabled="isLoading"
                  @change="onChangeQty($event, index)"
                />
                <div class="addon-qty-bundling">
                  {{ catalogUom }}
                </div>
              </a-input-group>
            </td>
            <td>
              <a-popconfirm
                placement="left" 
                :title="$t('product.remove_bundling_confirm')"
                @confirm="onRemoveCatalogBundling(index)"
              >
                <a-icon v-if="!isLoading" type="delete" />
              </a-popconfirm>
            </td>
          </tr>
        </tbody>
      </table>

      <a-button type="primary" class="mt-4" :disabled="isLoading" @click="showModalBundling = true">
        <a-icon type="plus" />
        {{ $t('product.add_product') }}
      </a-button>

      <a-modal
        :visible="showModalBundling"
        :footer="null"
        :title="$t('product.add_product_bundling')"
        :width="500"
        centered
        @cancel="onCloseModalBundling"
      >
        <a-form-model-item :label="$t('product.search_product')" class="mb-0">
          <a-select
            :value="keyword"
            show-search
            size="large"
            :placeholder="$t('product.enter_product_name_sku')"
            class="select-antd-default"
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            :disabled="!inventoryList.length"
            @search="fetchProductCatalogs"
            @change="onSelectCatalog"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="productCatalog in productCatalogs" :key="productCatalog.id" :value="productCatalog.id">
              {{ productCatalog.title }}
              <div style="font-size: 13px">
                <b>SKU: {{ productCatalog.sku }}</b>
              </div>
            </a-select-option>
          </a-select>
          <div v-if="notes" class="mt-1 ant-form-explain text-danger">
            {{ notes }}
          </div>
        </a-form-model-item>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { getProductMasterList } from '@/api/product'
import debounce from 'lodash/debounce'

import InputNumber from '@/components/Input/InputNumber.vue'
import InputNumberDecimal from '@/components/Input/InputNumberDecimal.vue'

export default {
  name: 'SingleVariant',
  components: {
    InputNumber,
    InputNumberDecimal,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: 'IDR',
    },
    uom: {
      type: Array,
      default: () => [],
    },
    businessId: {
      type: String,
      default: '',
    },
    inventories: {
      type: Array,
      default: () => [],
    },
    validateSku: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isProductBundling: false,
      showModalBundling: false,
      fetching: false,
      keyword: '',
      tempKeyword: '',
      priceLabel: 0,
      productCatalogs: [],
    }
  },
  computed: {
    catalogs: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    isLoading() {
      return this.loading
    },
    idBusiness() {
      return this.businessId
    },
    catalogUom() {
      return this.catalogs.items[0].price.uom
    },
    uomList() {
      return this.uom
    },
    inventoryList() {
      return this.inventories
    },
    notes() {
      const keyword = this.tempKeyword
      return !this.inventories.length
        ? this.$t('product.select_warehouse_first')
        : this.inventories.length && keyword.length < 2
        ? this.$t('product.min_chars_search')
        : ''
    },
  },
  watch: {
    inventoryList(val) {
      if (val.length && this.catalogs.bundling.bundles.length) {
        this.onSetItems(val)
      } else {
        this.catalogs.bundling.bundles = []
      }
    },
  },
  methods: {
    fetchProductCatalogs: debounce(async function(value) {
      const keyword = value.trim()
      const keywordLength = keyword.length
      this.tempKeyword = keyword
      if (!this.inventoryList.length && keywordLength < 2) return

      this.fetching = true
      await getProductMasterList({
        business_id: this.idBusiness,
        params: {
          business_id: this.idBusiness,
          q: keyword,
          page: 1,
          limit: 99,
          warehouse_id: this.inventoryList.map(inventory => inventory.id).join(),
          is_bundling: false,
        },
      })
      .then(({ data: { data: response } }) => {
        const data = []
        response?.forEach(product => {
          product?.catalogs?.forEach(catalog => {
            data.push({
              id: catalog.product_id + ';' + catalog.id + ';' + catalog.sku + ';' + catalog.title + ';' + product.warehouses,
              sku: catalog.sku,
              title: catalog.title,
            })
          })
        })
        this.productCatalogs = data
      })
      .catch(() => this.productCatalogs = [])
      .finally(() => this.fetching = false)
    }, 500),
    onSetItems: debounce(async function(inventories) {
      await getProductMasterList({
        business_id: this.idBusiness,
        params: {
          business_id: this.idBusiness,
          warehouse_id: inventories.map(inventory => inventory.id).join(),
          product_ids: this.catalogs.bundling.bundles.map(item => item.product_id).join(),
          page: 1,
          limit: 99,
          is_bundling: true,
        },
      })
      .then(({ data: { data: response } }) => {
        let filteredItems = []
        if (response?.length) {
          response.forEach(product => {
            product?.catalogs?.forEach(catalog => {
              const findItem = this.catalogs.bundling.bundles.find(item => item.product_id === product.id && item.catalog_id === catalog.id)
              if (findItem?.catalog_id) {
                const message = this.onCheckWarehouses(findItem.warehouses)
                filteredItems.push({ ...findItem, message })
              }
            })
          })
        }
        this.catalogs.bundling.bundles = filteredItems
      })
      .catch(() => this.catalogs.bundling.bundles = [])
    }),
    onCheckWarehouses(warehouses) {
      if (warehouses.length >= this.inventoryList.length) {
        let countWarehouse = 0
        this.inventoryList.forEach(inv => {
          const warehouseIndex = warehouses.findIndex(whs => whs === inv.id)
          if (warehouseIndex > -1) countWarehouse++
        })
        if (countWarehouse >= this.inventoryList.length) return ''
      }
      return this.$t('product.sku_not_in_warehouse')
    },
    onCheckSku(event, index) {
      this.$emit('checksku', { sku: event.target.value?.toUpperCase(), index })
    },
    onChangeSymbol(value, index) {
      this.priceLabel = 0
      this.catalogs.items[index].price.value = 0
      this.$emit('validate', `catalogs.items.${index}.price.value`)
    },
    onBlurPrice(value, index) {
      this.catalogs.items[index].price.value = value
      this.$emit('validate', `catalogs.items.${index}.price.value`)
    },
    onSelectCatalog(value) {
      const productCatalogs = value.split(';')
      const existingIndex = this.catalogs.bundling.bundles.findIndex(item => item.product_id === productCatalogs[0] && item.catalog_id === productCatalogs[1])
      if (existingIndex > -1) {
        this.catalogs.bundling.bundles[existingIndex].quantity += 1
      } else {
        const warehouses = productCatalogs[4].split(',')
        const message = this.onCheckWarehouses(warehouses)
        this.catalogs.bundling.bundles.push({
          product_id: productCatalogs[0],
          catalog_id: productCatalogs[1],
          sku: productCatalogs[2],
          title: productCatalogs[3],
          quantity: 1,
          uom: this.catalogUom,
          warehouses,
          message,
        })
      }
      this.productCatalogs = []
      this.showModalBundling = false
    },
    onRemoveCatalogBundling(index) {
      this.catalogs.bundling.bundles.splice(index, 1)
    },
    onChangeUom(value, index) {
      this.$emit('changeUom', { index, value })
    },
    onChangeBundle(event) {
      this.catalogs.bundling.bundling_type = event.target.checked ? 'SOFT' : null
      this.catalogs.bundling.bundles = []
    },
    onChangeQty(value, index) {
      if (!value) {
        this.catalogs.bundling.bundles[index].quantity = 1
      }
    },
    onCloseModalBundling() {
      this.keyword = ''
      this.tempKeyword = ''
      this.productCatalogs = []
      this.showModalBundling = false
    },
  },
}
</script>

<style lang="scss">
.table-bundling {
  width: 700px;
  border-collapse: collapse;

  th {
    background-color: #f8f8f8;
  }

  td, th {
    border: 1px solid #f1f1f1;
    padding: 8px;
  }

  td:first-child,
  th:first-child,
  td .ant-input-number {
    width: 65%;
  }

  td:last-child,
  th:last-child {
    width: 8%;
    text-align: center;
  }

  i {
    color: red;
    cursor: pointer;
  }
}

.addon-qty-bundling {
  width: 35%;
  padding: 9px 8px 8px;
  text-align: center;
  background-color: #f0f2f4;
  border: 1px solid #e4e9f0;
}

.ant-input-number {
  box-shadow: none !important;
}
</style>